import React from 'react';
import classnames from 'classnames/bind';
import styles from './sliderButton.module.scss';
const cx = classnames.bind(styles);

interface SliderButtonProps {
  visible?: boolean;
  type?: 'prev' | 'next';
  handleClick?: () => void;
  top?: number;
}

const SliderButton = ({ visible = false, handleClick, type, top }: SliderButtonProps) => {
  if (!visible) return null;
  return (
    <a className={cx('btnArrow', `${type}`)} style={{ top: top }} role="button" onClick={handleClick}>
      <span className={cx('hidden')}>{type}</span>
    </a>
  );
};

export default SliderButton;
